import { SubscriptionIntegration } from "@redotech/redo-model/subscription-integrations/subscription-integration";
import { RedoModal } from "@redotech/redo-web/arbiter-components/modal/redo-modal";
import { Flex } from "@redotech/redo-web/flex";
import { Text } from "@redotech/redo-web/text";
import { memo } from "react";

interface SkipSubscriptionModalProps {
  subscription: SubscriptionIntegration;
  isOpen: boolean;
  onClose: () => void;
  onConfirm: (subscriptionId: number) => void;
  isLoading?: boolean;
}

export const SkipSubscriptionModal = memo(function SkipSubscriptionModal({
  subscription,
  isOpen,
  onClose,
  onConfirm,
  isLoading = false,
}: SkipSubscriptionModalProps) {
  const handleConfirm = () => {
    onConfirm(subscription.id);
  };

  return (
    <RedoModal
      hideCloseButton={isLoading}
      isOpen={isOpen}
      modalSize="sm"
      onModalCloseRequested={onClose}
      primaryButton={{
        text: "Skip next charge",
        onClick: handleConfirm,
        disabled: isLoading,
        pending: isLoading,
      }}
      secondaryButton={{
        text: "Cancel",
        onClick: onClose,
        disabled: isLoading,
      }}
      title="Skip next charge?"
    >
      <Flex dir="column" gap="md">
        <Text fontSize="sm" textColor="secondary">
          Are you sure you want to skip the next charge for this subscription?
          The next scheduled charge will be delayed to the following billing
          cycle.
        </Text>
        {subscription.product && (
          <Flex dir="column" gap="xs">
            <Text fontSize="sm" fontWeight="medium">
              {subscription.product.name}
            </Text>
            <Text fontSize="sm" textColor="secondary">
              Quantity: {subscription.quantity}
            </Text>
          </Flex>
        )}
      </Flex>
    </RedoModal>
  );
});
